<template>

    <div class="flex justify-center items-center  py-4 text-sm ">
        <div @click="changeLocale('ar')" :class="[
            'cursor-pointer font-medium transition-all duration-200 hover:scale-105 px-3 ',
            locale === 'ar' ? 'text-' + brandTheme + '-primary underline' : 'text-' + brandTheme + '-dark hover:text-' + brandTheme + '-primary'
        ]">
            العربية
        </div>
        <div class="text-gray-400">|</div>
        <div @click="changeLocale('fr')" :class="[
            'cursor-pointer font-medium transition-all duration-200 hover:scale-105  px-3 ',
            locale === 'fr' ? 'text-' + brandTheme + '-primary underline' : 'text-' + brandTheme + '-dark hover:text-' + brandTheme + '-primary'
        ]">
            Français
        </div>
    </div>
</template>

<script setup>


import { useParticipationStore } from '@/stores/useParticipationStore'
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
const { locale } = useI18n()
const participationStore = useParticipationStore();


const brandTheme = ref('')
onMounted(() => {
    brandTheme.value = participationStore.participation?.brand ?? 'cocacola';
})

function changeLocale(code) {

    locale.value = code
}


</script>